import React from 'react';
export function Guarantee() {
  return <section className="bg-cream py-10 sm:py-16 px-5" data-id="element-126">
      <div className="max-w-6xl mx-auto" data-id="element-127">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-128">
          Sin riesgo
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-8 sm:mb-12 leading-tight" data-id="element-129">
          Tu compra está protegida
        </h2>

        <div className="max-w-2xl mx-auto bg-white rounded-2xl p-6 sm:p-12 text-center shadow-lg border-2 border-[#e8f7f0]" data-id="element-130">
          <div className="text-4xl sm:text-6xl mb-4 sm:mb-5" data-id="element-131">🛡️</div>
          <h2 className="font-display text-xl sm:text-3xl font-bold text-navy mb-3 sm:mb-4" data-id="element-132">
            Garantía 7 días
          </h2>
          <p className="text-[11px] sm:text-base text-gray-700 leading-relaxed mb-2" data-id="element-133">
            Abrís los tomos, usás los guiones y las plantillas en tu próxima
            consulta. Si en 7 días no notás la diferencia — o si el material no
            es lo que esperabas — te devolvemos el 100% del dinero.
          </p>
          <p className="text-[11px] sm:text-base text-gray-700 leading-relaxed mb-4" data-id="element-134">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <small className="text-[10px] sm:text-sm text-gray" data-id="element-135">
            Tasa de devoluciones menor al 1% — porque cuando alguien aplica las
            herramientas, los resultados son inmediatos.
          </small>
        </div>
      </div>
    </section>;
}